import axiosInstance from './AxiosInstance';

/**
 * Obtiene el perfil completo del usuario autenticado
 * GET /perfil-usuario
 */
export function getUserProfile() {
    return axiosInstance.get('/perfil-usuario');
}

/**
 * Actualiza el perfil completo del usuario
 * PUT /perfil-usuario
 * @param {Object} profileData - Datos completos del perfil
 */
export function updateUserProfile(profileData) {
    return axiosInstance.put('/perfil-usuario', profileData);
}

/**
 * Actualiza campos específicos del perfil del usuario
 * PATCH /perfil-usuario
 * @param {Object} profileData - Datos parciales del perfil a actualizar
 */
export function patchUserProfile(profileData) {
    return axiosInstance.patch('/perfil-usuario', profileData);
}

export function updateProfilePicture(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post('/perfil-usuario/foto-perfil', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

